import React from 'react';
import {
  Alert,
  Box,
  BoxProps,
  Button,
  styled,
  Typography,
} from '@mui/material';
import { Edit } from '@mui/icons-material';

interface ObAlertProps extends BoxProps {
  title: string;
  type?: 'success' | 'error' | 'info';
  onClick?: () => void;
}

const Wrapper = styled(Box)(({ theme }) => ({
  '& + &': {
    marginTop: theme.spacing(4),
  },

  '& .MuiAlert-outlinedSuccess': {
    backgroundColor: '#4caf500d',
  },

  '& .MuiAlert-outlinedError': {
    backgroundColor: '#f443360d',
  },

  '& .MuiAlert-outlinedInfo': {
    backgroundColor: '#2196f30d',
  },

  '& .MuiAlert-message': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 0,

    '& .MuiTypography-root': {
      fontSize: 14,
    },
  },

  '& .MuiButton-root': {
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(0.25, 1),
    fontSize: 12,
    minWidth: 'auto',

    '&:hover': {
      boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.3)',
    },

    '& .MuiSvgIcon-root': {
      fontSize: 12,
      marginRight: theme.spacing(0.5),
    },
  },
}));

const ObAlert: React.FC<ObAlertProps> = ({
  children,
  title,
  type,
  onClick,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      <Typography
        variant="body2"
        fontSize={13}
        fontWeight={500}
        textTransform="uppercase"
        gutterBottom
      >
        {title}
      </Typography>
      <Alert
        variant="outlined"
        severity={type}
        action={
          onClick && (
            <Button color="inherit" onClick={onClick}>
              <Edit /> Edit
            </Button>
          )
        }
      >
        {children}
      </Alert>
    </Wrapper>
  );
};

export default ObAlert;
